import iconDelete from './images/icon-delete.svg';
import iconEdit from './images/icon-edit.svg';
import iconMinus from './images/icon-minus.svg';
import iconPlus from './images/icon-plus.svg';
import iconPlusActive from './images/icon-plus-active.svg'
import iconMinusActive from './images/icon-minus-active.svg'
import iconReply from './images/icon-reply.svg';
import imageAmy from './images/avatars/image-amyrobson.png';
import imageJiuliusomo from './images/avatars/image-juliusomo.png';
import imageMaxBlaGun from './images/avatars/image-maxblagun.png';
import imageRamsesmiron from './images/avatars/image-ramsesmiron.png';

const imagesResource = {
    iconDelete, iconEdit, iconMinus, iconPlus,iconReply, imageJiuliusomo, imageMaxBlaGun,imageAmy,imageRamsesmiron,iconPlusActive,iconMinusActive
}

export default imagesResource;